import React, { Fragment, useEffect, } from 'react';
import { Button, } from 'reactstrap';
import { sortBy, groupBy, trim, isEmpty, chunk, mapValues, orderBy, get, pick, omit, uniqBy, keyBy, } from 'lodash';
import { toast, } from 'react-toastify';
import { format as formatDate, addMonths, startOfDay, endOfDay, } from 'date-fns';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import moji from 'moji';
import jsbarcode from 'jsbarcode';
import { jsPDF } from 'jspdf';
import qs from 'qs';
import { useToggle, useCounter } from 'react-use';

import firebase from '../../firebase';
import { getCollectionData, batch } from '../../shared/firebase';
import { computeDocumentNumberForBarcode, computeCsvYamatoBoxSize, computeCsvSagawaBoxSize, types, returnDestinations, fields, statuses, boxSizes, deliveryTypes, deliveryType, getCombinedItems, } from '../../shared/models/combiningRequest';
import { amazonCombiningRequestDocumentNumbersSettingFields, } from '../../shared/models/setting';
import { fieldDisplayValue, postalCodeWithHyphen, idWithTenant, } from '../../shared/util';
import { deliveryTimes, prefectures, } from '../../shared/config';
import { newId, fullPathWithParams, } from '../../util';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useCollectionsFetch from '../hooks/useCollectionsFetch';
import useDocumentsFetch from '../hooks/useDocumentsFetch';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import useQueryParams from '../hooks/useQueryParams';
import AdminPage from '../hocs/AdminPage';
import ModelFormModal from '../modals/ModelFormModal';
import CombiningRequestFormModal from '../modals/CombiningRequestFormModal';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import ExportButton from '../ExportButton';
import QueryInput from '../QueryInput';
import QuerySelector from '../QuerySelector';
import DateSelector from '../DateSelector';
import ModalButton from '../ModalButton';
import BatchImportButton from '../BatchImportButton';
import ProductTagsDisplay from '../ProductTagsDisplay';
import TenantTags from '../TenantTags';

const { keys, entries } = Object;
const db = firebase.firestore();
const storageRef = firebase.storage().ref();
const inventoriesRef = db.collection('inventories');
const locationsRef = db.collection('locations');
const tenantsRef = db.collection('tenants');
const tagsRef = db.collection('tags');
const productsRef = db.collectionGroup('products');
const sendersRef = db.collectionGroup('senders');
const combiningRequestsRef = db.collectionGroup('combiningRequests');
const statusesByLabel = mapValues(keyBy(entries(statuses), _ => _[1].label), '0');
const combiningRequestsCsvInfoRef = db.collection('settings').doc('combiningRequestsCsvInfo');
const amazonCombiningRequestDocumentNumbersSettingRef = db.collection('settings').doc('amazonCombiningRequestDocumentNumbers');
const statusOptions = entries(statuses).map(([k, v]) => ({ label: v.label, value: k }));
const replaceSpaceAndChar = _ => _.replace(/[ 　]([a-zA-Z])/g, 'ー$1');
const trimAndReplaceDashAndEtc = _ => trim(_).replace(/[-ー―−‐—]/g, '-').replace(/\t/, '');

export default AdminPage(function AdminCombiningRequests (props) {
  const { location, history } = props;
  const queryParams = useQueryParams();
  const {
    startOn: startOnString,
    endOn: endOnString,
    combiningRequestIdQuery,
    statuses: statusesForFilter = [],
    tenantIds: tenantIdsForFilter = [],
    documentNumberQuery,
  } = useQueryParams();
  const startOn = new Date(startOnString);
  const endOn = new Date(endOnString);
  const [tenantIdForFilter] = tenantIdsForFilter;
  let filteredCombiningRequestsRef = combiningRequestsRef;
  if(!isEmpty(tenantIdForFilter)) {
    filteredCombiningRequestsRef = tenantsRef.doc(tenantIdForFilter).collection('combiningRequests');
  }
  if(!isEmpty(statusesForFilter)) {
    filteredCombiningRequestsRef = filteredCombiningRequestsRef.where('status', 'in', statusesForFilter);
  }
  filteredCombiningRequestsRef = filteredCombiningRequestsRef.orderBy('createdAt', 'desc');

  const locations = useCollectionSubscription(locationsRef);
  const locationsById = keyBy(locations, 'id');
  const combiningRequests = useCollectionSubscription(filteredCombiningRequestsRef, [startOnString, endOnString, tenantIdForFilter, statusesForFilter.join(''), documentNumberQuery]);
  const tenants = useCollectionSubscription(tenantsRef.orderBy('createdAt'));
  const tags = useCollectionSubscription(tagsRef.orderBy('createdAt'));
  const tenantsById = keyBy(tenants, 'id');
  const tagsById = keyBy(tags, 'id');
  const tenantOptions = tenants.map(_ => ({ label: `[${_.id}] ${_.name}`, value: _.id }));
  const products = useDocumentsFetch(uniqBy(combiningRequests.map(cr => [...cr.items.map(_ => cr.ref.parent.parent.collection('products').doc(_.productId)), ...getCombinedItems(cr).map(_ => cr.ref.parent.parent.collection('products').doc(_.productId))]).flat(), idWithTenant), [combiningRequests]);
  const productsById = keyBy(products.filter(_ => _), _ => idWithTenant(_.ref));
  const isSearching = !isEmpty(documentNumberQuery);
  const combiningRequestItems = combiningRequests;
  let filteredCombiningRequestItems = combiningRequestItems;
  if(combiningRequestIdQuery) {
    filteredCombiningRequestItems = filteredCombiningRequestItems.filter(_ => idWithTenant(_.ref).includes(combiningRequestIdQuery));
  }
  const sortedCombiningRequests = orderBy(filteredCombiningRequestItems, _ => _.createdAt.toDate(), 'desc');
  useEffect(() => {
    if(isEmpty(statusesForFilter)) {
      const path = fullPathWithParams({ statuses: ['initial', 'waitingToReceive', 'waitingToCombine', 'processing'], }, location);
      history.replace(encodeURI(path));
    }
  }, []);

  return (
    <div className="admin-combiningRequests container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="d-flex justify-content-center mb-3">
          <h4>加工依頼管理</h4>
        </div>
        <div className="mb-3 d-flex align-items-end justify-content-between gap-1">
          <div className="d-flex align-items-end gap-1">
            <div className="card">
              <div className="card-header">
                絞り込み
              </div>
              <div className="card-body">
                <div className="d-flex flex-wrap gap-1">
                  <div style={{ width: 300 }}>
                    <QuerySelector className="w-100" paramName="statuses" isMulti options={statusOptions} label="ステータスで絞込み" />
                  </div>
                  <div style={{ width: 150 }}>
                    <QuerySelector className="w-100" paramName="tenantIds" options={tenantOptions} label="テナントで絞込み" />
                  </div>
                  <div style={{ width: 150 }}>
                    <QueryInput width={null} paramName="combiningRequestIdQuery" label="加工依頼IDで検索" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex gap-1">
            <ListButton combiningRequests={sortedCombiningRequests.filter(_ => _.status === 'waitingToCombine')} />
          </div>
        </div>
        <div className="mb-2">
          {numeral(sortedCombiningRequests.length).format('0,0')}件
        </div>
        <div className="overflow-scroll position-relative" style={{ zIndex: 0 }}>
          {
            sortedCombiningRequests.length > 0 ? (
              <table className="table sticky-table table-bordered">
                <thead className="thead-light text-center">
                  <tr className="text-nowrap">
                    <th></th>
                    <th style={{ minWidth: 100 }}>ステータス</th>
                    <th style={{ minWidth: 150 }}>会社</th>
                    <th style={{ minWidth: 150 }}>
                      <div>加工依頼ID</div>
                      <div>加工依頼日</div>
                      <div>加工日</div>
                    </th>
                    <th style={{ minWidth: 150 }}>商品ID</th>
                    <th style={{ minWidth: 150 }}>品名</th>
                    <th style={{ minWidth: 200 }}>加工元商品名</th>
                    <th style={{ minWidth: 150 }}>SKU / FNSKU</th>
                    <th style={{ minWidth: 100 }}>数量</th>
                    <th style={{ minWidth: 200 }}>完成商品</th>
                    <th style={{ minWidth: 50 }}>完成数量</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    sortedCombiningRequests.map((combiningRequest) => {
                      const { id, ref, type = 'normal', combiningItems = [], items = [], senderId, orderNumber, postalCode, prefecture, city, address1, address2, name, phone, deliveryDate, deliveryTime = 'free', combiningOptionValues = [], status, ref: { parent: { parent: { id: tenantId } } }, files = [], returnDestination, plan, createdAt, completedAt, } = combiningRequest;
                      const tenant = tenantsById[tenantId];
                      const combinedItems = getCombinedItems(combiningRequest);
                      const rowItems = items.length > 0 ? items : [{}];
                      const tenantProducts = products.filter(_ => _.ref.parent.parent.id === tenantId);
                      const { color } = statuses[status];
                      const processValues = (values) => {
                        return {
                          ...values,
                          productIds: values.items.map(_ => _.productId),
                          ...(!['shipped', 'discarded'].includes(status) && ['shipped', 'discarded'].includes(values.status) && { completedAt: new Date() }),
                        };
                      };

                      return tenant != null && (
                        <Fragment key={idWithTenant(ref)}>
                          {
                            rowItems.map((item, i) => {
                              const { productId, ngQuantity } = item;
                              const product = productsById[[tenant.id, productId].join('-')];
                              return (
                                <tr key={tenant.id + id + i} className={`table-${color}`}>
                                  {
                                    i === 0 && (
                                      <Fragment>
                                        <td rowSpan={rowItems.length} className="text-nowrap">
                                          <EditButton itemRef={ref} processValues={processValues} FormModal={CombiningRequestFormModal} formProps={{ products: tenantProducts, tenant, admin: true }} />
                                        </td>
                                        <td rowSpan={rowItems.length}>
                                          {statuses[status].label}
                                        </td>
                                        <td rowSpan={rowItems.length}>
                                          <Link to={`/admin/tenants/${tenant.id}`}>
                                            {tenant.name}
                                          </Link>
                                          <TenantTags tagIds={tenant.tagIds} tagsById={tagsById} />
                                        </td>
                                        <td rowSpan={rowItems.length}>
                                          <div>{tenant.id}-{id}</div>
                                          <div>{formatDate(createdAt.toDate(), 'yyyy/MM/dd')}</div>
                                          <div>{completedAt ? formatDate(completedAt.toDate(), 'yyyy/MM/dd') : '(加工日なし)'}</div>
                                        </td>
                                      </Fragment>
                                    )
                                  }
                                  <td>{product && `${tenant.id}-${product.id}`}</td>
                                  <td>{product && product.itemName}</td>
                                  <td>
                                    <ProductTagsDisplay product={product} productTags={[]} />
                                    <div>{product && product.name}</div>
                                  </td>
                                  <td>
                                    <div>
                                      {product && product.sku}
                                    </div>
                                    <div>
                                      {product && product.fnsku}
                                    </div>
                                  </td>
                                  <td className="text-right">{item.quantity}</td>
                                  {
                                    i === 0 && (
                                      <Fragment>
                                        <td rowSpan={rowItems.length}>
                                          {
                                            combinedItems.map(({ productId }, ci) => {
                                              const combinedProduct = productsById[[tenant?.id, productId].join('-')];
                                              return (
                                                <div key={ci} className={ci > 0 ? 'mt-2 pt-2 border-top' : ''}>
                                                  <ProductTagsDisplay product={combinedProduct} productTags={[]} />
                                                  <div className="text-muted small d-flex gap-1">
                                                    <div>{combinedProduct && combinedProduct.sku}</div>
                                                  </div>
                                                  <div className="d-flex align-items-start gap-1">
                                                    <div className="flex-grow-1 text-wrap">
                                                      <span>{combinedProduct?.name}</span>
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            })
                                          }
                                        </td>
                                        <td rowSpan={rowItems.length} className="text-right">
                                          {
                                            combinedItems.map(({ quantity }, ci) => (
                                              <div key={ci} className={ci > 0 ? 'mt-2 pt-2 border-top' : ''}>
                                                {numeral(quantity).format('0,0')}
                                              </div>
                                            ))
                                          }
                                        </td>
                                      </Fragment>
                                    )
                                  }
                                </tr>
                              )
                            })
                          }
                        </Fragment>
                      );
                    })
                  }
                </tbody>
              </table>
            ) : (
              <div>
                加工依頼が見つかりません
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
});

function ListButton (props) {
  const { combiningRequests, ...extraProps } = props;
  const [isClicked, toggleClicked] = useToggle(false);
  const scale = 2;
  const pdfWidth = 210;
  const barcodeWidth = 29;
  const barcodeHeight = 20;
  const textAreaWidth = 80;
  const onClick = () => {
    toggleClicked(true);
    window.open(`/admin/combiningRequestList?${qs.stringify({ ids: combiningRequests.map(_ => ({ tenantId: _.ref.parent.parent.id, combiningRequestId: _.id })), })}`);
  };
  const onSubmit = async () => {
    await batch(db, combiningRequests, (batch, combiningRequest) => {
      batch.update(combiningRequest.ref, { status: 'processing', });
    });
    toggleClicked(false);
  };

  return (
    <Fragment>
      <Button onClick={onClick} {...extraProps}>
        リスト
      </Button>
      {isClicked && <ModelFormModal isOpen title="確認" fields={{}} onClickClose={toggleClicked.bind(null, false)} onSubmit={onSubmit} submitLabel="印刷した" renderFormHeader={_ => <div>リストを印刷しましたか？（加工作業中にします）</div>} />}
    </Fragment>
  );
}
